import { normalizeMenuUrl } from "./menuUrl";

export function parseListIndexFromHit(hit) {
  if (typeof hit?.listIndex === "number" && !Number.isNaN(hit.listIndex)) {
    return hit.listIndex;
  }

  if (typeof hit?.id === "string") {
    const match = hit.id.match(/_list_(\d+)$/);
    if (match) return Number(match[1]);
  }

  return null;
}

export function isNumericRecordId(value) {
  return (
    typeof value === "number" ||
    (typeof value === "string" && /^\d+$/.test(value.trim()))
  );
}

export function buildNewsListLookups(list) {
  const byListIndex = new Map();
  const byTitle = new Map();
  const byNewsletterDocumentId = new Map();

  if (!Array.isArray(list)) {
    return { byListIndex, byTitle, byNewsletterDocumentId };
  }

  list.forEach((item, index) => {
    const newsId = item?.id;
    if (newsId == null) return;

    byListIndex.set(index, newsId);

    const title = String(item.newsTitle || item.title || "")
      .trim()
      .toLowerCase();
    if (title) {
      byTitle.set(title, newsId);
    }

    const newsletter = item.newsletter;
    if (!newsletter) return;

    if (newsletter.documentId) {
      byNewsletterDocumentId.set(String(newsletter.documentId), newsId);
    }
    if (newsletter.id != null) {
      byNewsletterDocumentId.set(String(newsletter.id), newsId);
    }
  });

  return { byListIndex, byTitle, byNewsletterDocumentId };
}

function pickRawUrl(hit) {
  const candidates = [hit?.url, hit?.path, hit?.link, hit?.slug];
  for (const value of candidates) {
    if (typeof value === "string" && value.trim()) {
      return value.trim();
    }
  }
  return "";
}

/**
 * Resolve a navigable /news/:id URL using the CMS news list.
 */
export function resolveNewsHitUrl(hit, lookups) {
  const normalized = normalizeMenuUrl(pickRawUrl(hit));
  if (normalized) return normalized;

  const contentType = String(hit?.contentType || "").toLowerCase();

  if (contentType === "news-page") {
    return "/news";
  }

  if (contentType === "news-list-item") {
    const listIndex = parseListIndexFromHit(hit);
    if (listIndex != null && lookups.byListIndex.has(listIndex)) {
      return `/news/${lookups.byListIndex.get(listIndex)}`;
    }
  }

  if (contentType === "newsletter") {
    const newsletterKey = hit?.documentId;
    if (newsletterKey && lookups.byNewsletterDocumentId.has(String(newsletterKey))) {
      return `/news/${lookups.byNewsletterDocumentId.get(String(newsletterKey))}`;
    }
  }

  const title = String(hit?.title || "").trim().toLowerCase();
  if (title && lookups.byTitle.has(title)) {
    return `/news/${lookups.byTitle.get(title)}`;
  }

  const listIndex = parseListIndexFromHit(hit);
  if (listIndex != null && lookups.byListIndex.has(listIndex)) {
    return `/news/${lookups.byListIndex.get(listIndex)}`;
  }

  if (isNumericRecordId(hit?.id)) {
    return `/news/${hit.id}`;
  }

  return null;
}

export function isNewsSearchHit(hit) {
  const contentType = String(hit?.contentType || "").toLowerCase();
  return (
    contentType === "news-list-item" ||
    contentType === "newsletter" ||
    contentType === "news-page" ||
    contentType === "news" ||
    parseListIndexFromHit(hit) != null
  );
}
